import { useEffect, useState } from "react";
import {
  GetBillingProfilesOfUserAndTypeApi,
  GetBillingProfilesOfUserApi,
} from "../../../../../service/repos/customer/billing_profile_repo";
import { CustomerDetailModel } from "../../../../../service/models/orders/customer_detail_model";
import {
  ToastType,
  useToast,
} from "../../../../../context_providers/toast/toast_ctx";
import { Icon } from "@mdi/react";
import { mdiMapMarker } from "@mdi/js";

type Props = {
  user_id: any;
  selected_id?: any;
  type: "Billing" | "Delivery";
  onAdded: (customer: CustomerDetailModel) => void;
};

const SelectAddressProfileWidget = ({
  user_id,
  type,
  selected_id,
  onAdded,
}: Props) => {
  const [profiles, setProfiles] = useState<CustomerDetailModel[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(
    selected_id ?? null,
  );
  const { showToast } = useToast();

  useEffect(() => {
    const fetchData = async () => {
      let res = await GetBillingProfilesOfUserAndTypeApi(user_id, type);

      if (
        res.success &&
        res.data?.billing_profiles &&
        res.data.billing_profiles.length > 0
      ) {
        setProfiles(res.data.billing_profiles);
      } else {
        // fallback API
        const fallbackRes = await GetBillingProfilesOfUserApi(user_id);

        if (fallbackRes.success) {
          setProfiles(fallbackRes.data.billing_profiles);
        } else {
          showToast({ type: ToastType.error, text: fallbackRes.error });
        }
      }
    };

    fetchData();
  }, [user_id, type]);

  return (
    <div className="space-y-4">
      <p className="text-sm font-medium">Select an address</p>
      {profiles.map((profile) => (
        <label
          key={profile.id}
          className={`flex items-start border rounded p-3 gap-2 cursor-pointer ${
            selectedId === profile.id
              ? "border-myPrimaryColor bg-gray-50"
              : "border-gray-200"
          }`}
        >
          <input
            type="radio"
            checked={selectedId === profile.id}
            onChange={() => setSelectedId(profile.id)}
            className="mt-1"
          />
          <div className="text-xs">
            <p className="font-medium">
              {profile.firstName} {profile.lastName}
            </p>
            <p>{profile.email}</p>
            <div className="flex items-center gap-1 text-gray-500">
              <Icon path={mdiMapMarker} size={0.7} />
              <span>
                {profile.address?.line1}, {profile.address?.line2},{" "}
                {profile.address?.city}, {profile.address?.state},{" "}
                {profile.address?.country} - {profile.address?.pincode}
              </span>
            </div>
          </div>
        </label>
      ))}
      <div className="text-right">
        <button
          disabled={!selectedId}
          onClick={() => {
            const selected = profiles.find((p) => p.id === selectedId);
            if (selected) onAdded(selected);
          }}
          className={`px-4 py-2 rounded ${
            selectedId
              ? "bg-myPrimaryColor text-white"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
          }`}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default SelectAddressProfileWidget;
